import { InvoicesActionTypes } from './invoices.types';

export const initialState = {
  orderCancelStatus: undefined,
  orderCancelLoading: false,
  invoices: {
    listOfNfse: null,
    currentInvoiceId: [],
  },
  invoiceData: null,
  invoiceDetails: {
    data: null,
    loading: false,
    status: null,
  },
  qrCode: null,
  pixCode: null,
};

const alertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case InvoicesActionTypes.SET_INVOICE_DATA: {
      return {
        ...state,
        invoiceData: action.payload,
      };
    }
    case InvoicesActionTypes.SET_INVOICE_DETAILS: {
      return {
        ...state,
        invoiceDetails: {
          ...state.invoiceDetails,
          data: action.payload.data,
        },
      };
    }
    case InvoicesActionTypes.SUCCESS_INVOICE_DETAILS: {
      return {
        ...state,
        invoiceDetails: {
          ...state.invoiceDetails,
          status: 'success',
        },
      };
    }
    case InvoicesActionTypes.FAILURE_INVOICE_DETAILS: {
      return {
        ...state,
        invoiceDetails: {
          ...state.invoiceDetails,
          status: 'failure',
        },
      };
    }
    case InvoicesActionTypes.SET_INVOICE_DETAILS_LOADING: {
      return {
        ...state,
        invoiceDetails: {
          ...state.invoiceDetails,
          loading: action.payload,
        },
      };
    }
    case InvoicesActionTypes.RESET_INVOICE_DETAILS_STATE: {
      return {
        ...state,
        invoiceDetails: initialState.invoiceDetails,
      };
    }
    case InvoicesActionTypes.CANCEL_ORDER_SUCCESS:
    case InvoicesActionTypes.CANCEL_ORDER_FAILURE: {
      return {
        ...state,
        orderCancelStatus: action.payload,
      };
    }
    case InvoicesActionTypes.CANCEL_ORDER_LOADING: {
      return {
        ...state,
        orderCancelLoading: action.payload,
      };
    }
    case InvoicesActionTypes.SET_NFSE: {
      return {
        ...state,
        invoices: action.payload,
      };
    }
    case InvoicesActionTypes.SET_PIX: {
      return {
        ...state,
        qrCode: action.payload.qrCode,
        pixCode: action.payload.code,
        pixFailure: action.payload.failure,
      };
    }
    default:
      return state;
  }
};

export default alertsReducer;
